<style>

input[type="text"], input[type="password"], input[type="email"], input[type="number"], input[type="date"], textarea, select, .text-field {
  font-family: SenRegular;
  font-size: 20px;
  background-color: inherit;
  border: 0;
  border-bottom: none;
  height: 40px;
  border-radius: 0;
  width: 100%;
	padding: 7px 10px 9px 10px;
	box-sizing: border-box;
  outline: none;
  color: white;
}

.container{
  display: grid;
  grid-template-columns: 40px auto 40px;
  align-items: center;
  border-bottom: 1px gray solid;
}
.icon{
  grid-column: 1;
  margin-left: 10px;
  font-size: 20px;
  color: gray;
}
.input{
  grid-column: 2;
}
.trash{
  grid-column: 3;
  text-align: right;
  color: white;
}
</style>

<div class="container">
  <div class="icon"><i class="{actualIcon}"></i></div>
  <div class="text"><input type="text" bind:value="{link}" placeholder="{placeholder}" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"></div>
  <div class="trash" on:click="{ () => dispatch('delete', { index: index } ) }"><i class="icon-clear"></i></div>
</div>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let icon = "";
export let link = "";
export let index = -1;

let actualIcon = "";
let placeholder = "";

$: {
  // translate icon text into actual icon
  if (icon) {
    if (icon == "website") {
      actualIcon = "icon-globe";
      placeholder = "add website url";
    }
    if (icon == "facebook") {
      actualIcon = "icon-facebook";
      placeholder = "add facebook link";
    }
    if (icon == "instagram") {
      actualIcon = "icon-instagram";
      placeholder = "add instagram @user";
    }
    if (icon == "linkedin") {
      actualIcon = "icon-linkedin";
      placeholder = "add linkedin link";
    }
    if (icon == "snapchat") {
      actualIcon = "icon-snapchat";
      placeholder = "add snapchat user";
    }
    if (icon == "twitter") {
      actualIcon = "icon-twitter";
      placeholder = "add twitter user";
    }
  }
}


</script>